module.exports = __webpack_public_path__ + "static/how-to-create-account-7ee92f7f01814c01288dab562ab56894.png";